import React from 'react';
import StudentLayout from './components/StudentLayout';
import SupportTicketForm from '../shared/SupportTicketForm';

const StudentSupport = () => {
  return (
    <StudentLayout>
      <SupportTicketForm userRole="student" />
    </StudentLayout>
  );
};

export default StudentSupport;
